const AnjuAllReleases2021Static = () => {
    return (
      <>
        <div class="gallery_containerThree-static">  

        <div class="gallery_item">
            <p class="gallery-tag">DJ Set</p>
            <a href="https://soundcloud.com/anjuonline/club-kawaii" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-vejMf4Oh790upIGy-zsTVPA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>ANJU Online! @ Club Kawaii</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/anjuonline/anjucore" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-XiBwUD8ULuzzZwSy-dVmFNw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>ANJUcore</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/anjuonline/status-effect" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-HVZr9zrkM3AMnvyy-eHIY2g-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Status Effect</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/anjuonline/memory-leak" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-vnFtz9CytSEhbz0J-8xyrSw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Memory Leak</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/anjuonline/passing-brussels" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-wwoT34wzHbb7vSWv-fe9Xfg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Passing Brussels</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/anjuonline/observatory" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-wwoT34wzHbb7vSWv-fe9Xfg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Observatory</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/anjuonline/jailbroken-ipod-touch" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-wwoT34wzHbb7vSWv-fe9Xfg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Jailbroken iPod Touch</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/anjuonline/second-date" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-wwoT34wzHbb7vSWv-fe9Xfg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Second Date</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">DJ Set</p>
            <a href="https://soundcloud.com/anjuonline/dreamworld-festival" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-DNsLZpz5kUp9Qsly-PNoxbg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>ANJU Online! @ DREAMWORLD Festival</strong><br/>
              </p>
            </a>
          </div>

        </div>
      </>
    );
  };
  export default AnjuAllReleases2021Static;